import { useEffect, useCallback } from 'react';
import { useInputParameters } from '../../../helpers/useInputParameters';
import { ProgressIndicator } from '@veneer/core';
import { ScreenInfo, useDataCollection } from '../../../jarvis/dataCollection';
import { sendFinishedEvent } from '../../../jarvis/eventService';
import { LocalStorageHelper } from '../../../helpers/localStorage';

const screenInfo: ScreenInfo = { name: 'PaidSolutionsFrameworkCompletion', activity: 'OrderPhotobook-v01' };

const PSFCallbacksCheckoutPage = () => {
  const dataCollection = useDataCollection();

  const urlParams = useInputParameters();

  const sendViewEvent = useCallback(
    (screenMode: string) => {
      dataCollection.sendScreenViewEvent(screenInfo, screenMode);
    },
    [dataCollection],
  );

  const handleCheckoutProcess = useCallback(
    (status: string) => {
      if (!status) return console.log('Missing PSF checkout status');
      console.log('PSFCallbacksCheckoutPage::handleCheckoutProcess status', status);
      if (status === 'success') {
        LocalStorageHelper.clearProject();
        return sendViewEvent('Success');
      }
      if (status === 'error') return sendViewEvent('Error');
      if (status === 'canceled') return sendViewEvent('Canceled');
      console.log('Unknown PSF checkout status');
    },
    [sendViewEvent],
  );

  useEffect(() => {
    if (urlParams.status != undefined) handleCheckoutProcess(urlParams.status);
    console.log('Sending FinishedEvent');
    sendFinishedEvent();
  }, [urlParams, handleCheckoutProcess]);

  return (
    <div className="spinner">
      <ProgressIndicator />
    </div>
  );
};

export default PSFCallbacksCheckoutPage;
